module.exports = __webpack_public_path__ + "img/gas-station-night.d9524394.jpg";